angular
	.module 'App.Repository'

.factory 'DayTallyRepository', ['BaseRepository', (BaseRepository) ->
	class DayTallyRepository extends BaseRepository
		@resource = '/day_tallies'
		@isRestricted = true

	return new DayTallyRepository
]
